import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import {
  GetProjectInfos
} from "@/api"

export default new Vuex.Store({
  state: {
    token: "",
    uid: "",
    pid: "",
    QRcode: "",
    // pImg: 'http://101.132.170.121:8006/',
    // 群坡
    // pImg: 'http://192.168.1.237:64304',
    // pImg: 'https://xtapi.eabim.cn:8020/',
    // pImg: 'http://192.168.1.66:64305',
    pImg: 'https://api.shznjz.cn',
    pName: "",
    qid: "",
    schoolId: "",
    username: "",
    userImg: "",
    roleList: [],
    PlanList: [],
    // baseUrl: 'http://192.168.1.62:64305',
    // 温帅韬
    // baseURL: "http://192.168.1.207:64305",
    // baseUrl: 'http://192.168.1.135:64305',
    // baseUrl: 'https://xtapi.eabim.cn:8020/',
    baseUrl: 'https://api.shznjz.cn',
    // baseUrl: 'http://101.132.170.121:8006/',
    // baseUrl: 'http://192.168.1.102:64304/',
    // baseUrl: 'http://101.132.170.121:8006/',
    // 群坡
    // baseUrl: 'http://192.168.1.237:64304',
  },

  mutations: {
    SET_SCHOOLID: (store, id) => {
      store.schoolId = id;
    },
    SET_SCHOOLROLE: (store, role) => {
      store.roleList = role;
    },
  },
  getters: {
    qid: (state) => {
      return state.qid;
    },
    pid: (state) => {
      return state.pid;
    },
  },

  actions: {
    GetProjectInfos({
      state,
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        GetProjectInfos({
          params: {
            id: state.pid,
          }
        }).then(res => {
          resolve(res);
        })
      })
    },
  },
  modules: {}
})